module.exports = __webpack_public_path__ + "media/images/twitter-dbc32ea934c30c3dd2da07ec435c2ecf.svg";